import { Center, useDisclosure } from '@chakra-ui/react';
import { useScreenType } from '../../Shared/Hooks/useScreenType';
import NavigationToggle from '../NavigationToggle';
import MobileNavigation from '../MobileNavigation';
import DesktopNavigation from '../DesktopNavigation';

const Navigation = () => {
    const screenInfo = useScreenType();
    const isMobile = screenInfo?.screenSize === 'extrasmall';
    const { isOpen, onOpen, onClose } = useDisclosure();                   

    if (isMobile) {
        return (
            <Center paddingRight='20px'
                    fontSize='3xl'>
                <NavigationToggle onOpen={ onOpen }/>
                <MobileNavigation isOpen={ isOpen } onClose={ onClose }/>
            </Center>
        );
    };

    return (
        <Center>
            <DesktopNavigation />
        </Center>
    );
};

export default Navigation;